import { CustomerSubAccountMappings } from '@src/containers/Dealer/CustomerSubAccountMappings';
import type { CustomerSubAccountMappingsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerSubAccountMappingsPanel({
  api,
  params,
}: LayoutPanelProps<CustomerSubAccountMappingsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-sub-account-mappings-panel"
    >
      <CustomerSubAccountMappings />
    </EntityAdminPanelShell>
  );
}
